import { ActionIcon, Drawer } from "@mantine/core";
import { useRouter }          from "next/router";

import { PrimaryButton } from "_components/atoms/button";
import Icon              from "_components/atoms/icon";
import Modal             from "_components/atoms/modal";
import Typography        from "_components/atoms/typography";
import UnstyledButton    from "_components/atoms/unstyledButton";

import useStyles from "./styles";

function component ( { opened, onClose, handleClickDone, isMobile } ) {
	const { classes } = useStyles ();

	if ( isMobile ) {
		return (
			<Drawer
				classNames = { {
					content : classes.drawerContent,
					body    : classes.drawerBody
				} }
				onClose = { onClose }
				opened = { opened }
				position = { "bottom" }
				withCloseButton = { false }
			>
				<InnerComponent
					handleClickDone = { handleClickDone }
					isMobile = { isMobile }
				/>
			</Drawer>
		);

	}

	return (
		<Modal
			centered
			classNames = { {
				body    : classes.body,
				content : classes.content,
				root    : classes.modalRoot
			} }
			onClose = { onClose }
			opened = { opened }
			withCloseButton = { false }
			zIndex = { 1500 }
		>
			<InnerComponent
				handleClickDone = { handleClickDone }
				isMobile = { isMobile }
			/>
		</Modal>
	);
}

function InnerComponent ( { handleClickDone, isMobile } ) {
	const { classes, theme } = useStyles ();
	const router             = useRouter ();

	return (
		<div className = { classes.modalContentWrapper }>

			<ActionIcon
				className = { classes.closeIconWrapper }
				onClick = { handleClickDone }
			>
				<Icon name = { "crossWhite" }
					sameInBothTheme = { true }
					size = { "2rem" }
				/>
			</ActionIcon>

			<Icon name = { "pro-badge" }
				sameInBothTheme = { true }
				size = { "6rem" }
			/>

			<div className = { classes.title }>
				<Typography
					color = { theme.other.paletteNew.darkModeWhite80 }
					title = { "You are now Pro!" }
				/>

				<Typography color = { "secondary" }
					size = "sm"
					title = { "Happy Watching ✨" }
				/>
			</div>

			<div className = { classes.btnWrapper }>
				<PrimaryButton
					className = { classes.topBtn }
					onClick = { () => {
						if ( isMobile ) {
							router.replace ( "/?tab=693856" );
						}
						router.replace ( "/feed/693856?type=pro-streams" );
					} }
					title = { "Explore Pro Streams" }
				/>

				<UnstyledButton
					className = { classes.doneBtn }
					onClick = { handleClickDone }
					title = { (
						<Typography
							gradient = { {
								from : theme.other.paletteNew.aquaBlue,
								to   : theme.other.paletteNew.softBlue,
								deg  : 60
							} }
							title = { "Done" }
							variant = { "gradient" }
						/>
					) }
				/>
			</div>
		</div>
	);
}
export default component;
